import { useCurrentUser } from '_graphql/cache/auth';
import { CalendarHeader, OfficeButton, OfficeHeader, TableComponent } from 'components';
import React, { Fragment, useState } from 'react';
import UpdatePasswordContainer from './update-password';
import { usePagination } from 'hooks';
import { useEmployeeActivities } from 'hooks/data/use-employees';
import moment from 'moment';



type Statistics = {
    totalOffers: number;
    lastLogin: string;
};



const mockStats: Statistics = {
    totalOffers: 42,
    lastLogin: moment().subtract(1, 'day').format('MMMM Do YYYY, h:mm:ss a'),
};


const ProfilePage: React.FC = () => {
    const currentUser = useCurrentUser();
    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const { offset, limit, toDate, fromDate } = usePagination();
    const { activities, loading, refetch } = useEmployeeActivities({
        filter: {
            date_from: moment(fromDate).format('YYYY-MM-DD HH:mm:ss'),
            date_to: moment(toDate).endOf("D").format('YYYY-MM-DD HH:mm:ss'),
        }, pagination: {
            limit: limit,
            offset: offset
        }
    })
    return (
        <Fragment>
            <CalendarHeader renderActions={() => (
                <OfficeButton onClick={() => setShowUpdatePassword(true)} size='sm' variant='primary'>
                    Update Password
                </OfficeButton>
            )} />
            <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Profile Details Card */}
                    <div className="bg-card-500 rounded-lg shadow p-6 flex flex-col md:flex-row md:items-center gap-6 mb-8">
                        <div className="flex-shrink-0">
                            <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center text-3xl font-bold text-gray-500">
                                {`${currentUser.employee?.employee_first_name?.split(' ')[0][0]}${currentUser.employee?.employee_last_name?.split(' ')[0][0]}`}
                            </div>
                        </div>
                        <div className="flex-1">
                            <h2 className="text-2xl font-semibold text-gray-300 mb-2">{currentUser.employee?.employee_first_name} {currentUser.employee?.employee_last_name}</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-300">
                                <div>
                                    <span className="font-medium">Mobile:</span> {currentUser?.employee?.employee_phonenumber}
                                </div>
                                <div>
                                    <span className="font-medium">Email:</span> {currentUser?.employee?.employee_email}
                                </div>
                                <div>
                                    <span className="font-medium">Role:</span> {currentUser?.position}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Statistics */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                        <div className="bg-card-500 rounded-lg p-4 flex items-center">
                            <div className="bg-blue-100 rounded-full p-3 mr-4">
                                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-3xl font-semibold text-blue-700">{mockStats.totalOffers}</div>
                                <div className="text-gray-400">Total Offers</div>
                            </div>
                        </div>
                        <div className="bg-card-500 rounded-lg p-4 flex items-center">
                            <div className="bg-green-100 rounded-full p-3 mr-4">
                                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path d="M12 8v4l3 3" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="12" cy="12" r="10" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-xl font-semibold text-green-700">{mockStats.lastLogin}</div>
                                <div className="text-gray-400">Last Login</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-card-500 rounded-lg shadow p-6 mt-6">
                    <TableComponent hasSearch title={'Login Activities'} columns={[
                        { name: 'Device IP	', accessor: 'device_ip' },
                        { name: 'Device', accessor: 'device_type' },
                        { name: 'Country', accessor: 'country' },
                        { name: 'City', accessor: 'city' },
                        { name: 'Logged in on', accessor: 'created_at' },

                    ]} data={activities} loading={loading} refetch={refetch} />
                </div>
            </div>
            <UpdatePasswordContainer open={showUpdatePassword} setOpen={setShowUpdatePassword} />
        </Fragment>
    );
};

export default ProfilePage;